/* eslint-disable default-case, no-param-reassign */
import { Reducer } from 'redux';
import { getType } from 'typesafe-actions';
import produce from 'immer';
import LocalStorageService from 'services/local-storage-service';
import { DEFAULT_DRAWER_WIDTH } from 'app-constants';
import { actions, DrawersActions } from '.';
import { DrawersState } from './types';

const initialState: DrawersState = {
  activeDrawers: [],
  width: LocalStorageService.getDrawerWidth() || DEFAULT_DRAWER_WIDTH,
};

const reducer: Reducer<DrawersState, DrawersActions> = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case getType(actions.openDrawerAction): {
        if (
          draft.activeDrawers[draft.activeDrawers.length - 1]?.drawerType ===
          action.payload.drawerType
        ) {
          break;
        }
        draft.activeDrawers.push(action.payload);
        break;
      }
      case getType(actions.closeDrawer): {
        draft.activeDrawers.pop();
        break;
      }
      case getType(actions.updateDrawerWidth): {
        LocalStorageService.updateDrawerWidth(action.payload);
        draft.width = action.payload;
        break;
      }
    }

    return draft as DrawersState;
  });

export default reducer;
